import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Story from 'zignal-landscape/lib/Story';
import Link from 'zignal-landscape/lib/Link';
import MediaObject from 'zignal-landscape/lib/MediaObject';
import TwitterIcon from 'zignal-landscape/lib/Icon/TwitterIcon';
import FacebookIcon from 'zignal-landscape/lib/Icon/FacebookIcon';
import WeiboIcon from 'zignal-landscape/lib/Icon/WeiboIcon';
import VkIcon from 'zignal-landscape/lib/Icon/VkIcon';
import ParsedTweetBody from 'zignal-widgets/lib/ParsedTweetBody';
import TwitterVerifiedAccountIcon from 'zignal-landscape/lib/Icon/TwitterVerifiedAccountIcon';
import Statistic from 'zignal-landscape/lib/Statistic';
import themeable from 'zignal-landscape/lib/themeable';
import { COLORS_BY_SENTIMENT } from 'containers/TrendingStoriesOverview/helper';

const OverviewStory = ({
  rank = null,
  timezone = 'EST',
  styles,
  story: {
    authorUrl,
    authorUsername,
    authorAvatarUrl,
    authorName,
    authorId,
    authorVerified,
    sourceType,
    body,
    displaySentiment,
    createdAt,
    url,
    retweetCount
  }
}) => {
  const sourceIcon = () => {
    switch (sourceType) {
      case 'weibo':
        return <WeiboIcon height="1em" width="1em" />;
      case 'vk':
        return <VkIcon height="1em" width="1em" />;
      case 'facebook':
        return <FacebookIcon height="1em" width="1em" />;
      case 'twitter':
        return <TwitterIcon height="1em" width="1em" />;
      default:
        return null;
    }
  };

  const getStatisticsLabel = () => {
    if (sourceType === 'twitter') {
      return retweetCount === 1 ? 'Retweet' : 'Retweets';
    }
    return retweetCount === 1 ? 'Engagement' : 'Engagements';
  };

  return (
    <div className={styles.storyWrapper}>
      <Story>
        {rank && <Story.Rank value={rank} />}
        <Story.Content lines={2}>
          <Story.Header>
            <MediaObject>
              <MediaObject.Image
                rounded
                style={{height: '2.75em', width: '2.75em'}}
                src={authorAvatarUrl || '/whitelabels/no-photo-default-author.png'}
              />
              <MediaObject.Content>
                <MediaObject.Header>
                  {authorName || authorId}
                  {authorVerified && <span>&nbsp;<TwitterVerifiedAccountIcon /></span>}
                </MediaObject.Header>
                <MediaObject>
                  <MediaObject.Content>
                    <MediaObject>
                      <MediaObject.Icon>
                        {sourceIcon()}
                      </MediaObject.Icon>
                      <MediaObject.Content>
                        <MediaObject.Description>
                          <Link
                            href={authorUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {authorUsername || authorId}
                          </Link>
                        </MediaObject.Description>
                      </MediaObject.Content>
                    </MediaObject>
                  </MediaObject.Content>
                </MediaObject>
              </MediaObject.Content>
            </MediaObject>
          </Story.Header>
          <Story.Body>
            <Story.Text>
              <ParsedTweetBody body={body} />
            </Story.Text>
          </Story.Body>
          <Story.Footer>
            <Story.Footer.Item>
              {moment(createdAt).tz(timezone).fromNow()}
            </Story.Footer.Item>
            <Story.Footer.Item>
              <span
                style={{
                  fontWeight: 'bold',
                  color: displaySentiment ? COLORS_BY_SENTIMENT[displaySentiment] : COLORS_BY_SENTIMENT.Unknown
                }}
              >
                {displaySentiment || 'Unknown'}
              </span>
            </Story.Footer.Item>
            <Story.Link href={url} target="_blank" />
          </Story.Footer>
        </Story.Content>
        <Story.StatisticPanel>
          <Statistic
            value={retweetCount}
            label={getStatisticsLabel()}
          />
        </Story.StatisticPanel>
      </Story>
    </div>
  );
};

OverviewStory.propTypes = {
  rank: PropTypes.number,
  story: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  timezone: PropTypes.string,
};

export default themeable(OverviewStory);
